import React, { Component } from 'react';
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import Warning from "@material-ui/icons/Warning";
import { FormControlLabel, Checkbox, Select, TextField, MenuItem, FormControl, InputLabel, FormHelperText, Radio, RadioGroup } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
import { FcCheckmark } from "react-icons/fc";
import Typography from "@material-ui/core/Typography";
import { getSelectedCustomer, getQloadCustomerList } from '../../../store/actions';
import { connect } from 'react-redux';
import history from '../../../../../src/history';
import Simplert from 'react-simplert';
import { authController, dataController } from '../../../store/api/api.js';
import authService from 'components/api-authorization/AuthorizeService';
import {
    container,
    title,
    main,
    mainRaised,
    mrAuto,
    whiteColor,
    blackColor,
    infoColor,
    mlAuto,
    hexToRgb,
} from "../../../../assets/jss/material-kit-pro-react.js";
import { isEmpty } from "lodash";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isFunctionExpression } from 'typescript';
import Client from 'getaddress-api';
import CustomDropdown from "../../../../components/CustomDropdown/CustomDropdown.js";
import { useState } from "react"
import PasswordChecklist from "react-password-checklist"

import LoadingData from '../../lottieLoading.js';

import JSFile from '../../../../../../ClientApp/package.json';

import { loadingPage } from '../../../store/actions';

import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const useStyles = theme => ({
    main,
    mainRaised,
    mrAuto,
    mlAuto,
    container: {
        ...container,
        zIndex: 2,
    },
    title: {
        ...title,
        "&, & + h4": {
            /*            color: whiteColor,*/
        },
    },
    textCenter: {
        textAlign: "center",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        margin: "0",
        float: "right!important",
        display: "block",
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    },
    subHeader: {
        ...title,
        "&, & + h2": {
        },
        padding: "20px 0 10px 0", textAlign: "justify"
    },
    content: {
        paddingBottom: "30px",
        paddingTop: "20px",
    },
    checked: {
        color: infoColor[0] + "!important",
    },
    checkedIcon: {
        width: "25px",
        height: "25px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", 0.54)",
        borderRadius: "3px",
    },
    uncheckedIcon: {
        width: "25px",
        height: "25px",
        padding: "9px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", .54)",
        borderRadius: "3px",
    },
    closebuttonPopUp: {
        backgroundColor: "#21B6A8", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "4px 2px", cursor: "pointer"
    },
    checkRoot: {
        padding: "14px",
        "&:hover": {
            backgroundColor:
                "rgba(" + hexToRgb(infoColor[0]) + ", 0.14) !important",
        },
    }
});




const errorMess = (msg) => toast.error(msg, {
    position: "bottom-right",
    autoClose: 9000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});


const notifyErrorMessage = () => toast.error('Please fill in the required fields before proceeding!', {
    position: "bottom-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});


const invalidPCMessage = () => toast.error('Invalid UK Postcode', {
    position: "bottom-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});



class RegisterInputClass extends Component {


    state = {

        email: '',
        password: '',
        confirmPassword: '',
        telephone: '',
        addressline1: '',
        addressline2: '',
        addressline3: '',
        addressline4: '',
        town: '',
        postcode: '',
        city: '',
        county: '',
        country: '',
        passwordMacth: false,

        addressList: [],
        apiAddressList: [],
        selectedAddress: [],
        active: false,

        didUserSave: false,

        //pop up message
        showAlert: false,
        typeAlert: '',
        titleAlert: '',
        messageAlert: '',


        //error message helpers
        telephonerror: false,
        addressline1error: false,
        postcodeError: false,
        cityError: false,
        townError: false,
        multipleErrors: false,
        canRegisterChoice: 'yes',
    }


    componentDidMount() {
        /*       localStorage.setItem('user', "ehfu8ebhfu8ebfeb");*/
        /*        const loggedInUser = localStorage.getItem("user");*/
        /*  localStorage.clear();*/
    }


    displayMessage = (type, title, message) => {
        this.setState({
            showAlert: true,
            typeAlert: type,
            titleAlert: title,
            messageAlert: message
        }, () => {
            window.scrollTo(0, 0);
        });
    }


    handlePopUpMessage = () => {
        this.setState({ showAlert: false });

        if (this.state.didUserSave == true) {
            /*            history.push('/Login');*/
            this.props.history.push('/Login');
        }
    }


    handleEmailChange = (e) => {
        this.setState({ email: e.target.value }, () => {
        });
    }

    handleCanRegisterChange = (e) => {
        const value = e.target.value;
        this.setState({ canRegisterChoice: value }, () => {
            if (value === 'no') {
                confirmAlert({
                    closeOnClickOutside: false,
                    customUI: ({ onClose }) => {
                        return (
                            <div className='custom-ui' style={{ height: '230px' }}>
                                <h3><b>Information</b></h3>
                                <h5>The Easi Order Portal is for account members only. Should you be interested in our products please visit our website at www.fpmccann.co.uk</h5>
                                <button
                                    onClick={() => {
                                        onClose();
                                        window.open('https://www.fpmccann.co.uk', '_blank');
                                    }}
                                >
                                    Visit Website
                                </button>
                                <button onClick={onClose}>OK</button>
                            </div>
                        );
                    }
                });
            }
        });
    }

    handlePhoneChange = e => {
        const x = /^(\d*\.)?\d+$/;
        if (e.target.value === '' || x.test(e.target.value)) {
            this.setState({ telephone: e.target.value, telephonerror: false }, () => {
            });
        };
    };

    handleAddressChange = (e) => {
        this.setState({ addressline1: e.target.value, addressline1error: false }, () => {
        });
    }

    handleCityChange = (e) => {
        this.setState({ city: e.target.value, cityError: false }, () => {
        });
    }

    handleTownChange = (e) => {
        this.setState({ town: e.target.value, townError: false}, () => {
        });
    }

    handleCountyChange = (e) => {
        this.setState({ county: e.target.value}, () => {
        });
    }



    handlePasswordChange = (e) => {
        this.setState({ password: e.target.value }, () => {
        });
    }

    handleconfirmPasswordChange = (e) => {
        this.setState({ confirmPassword: e.target.value }, () => {
        });
    }


    updatePasswordValResult = (value) => {

        if (this.state.passwordMacth !== value) {
            this.setState({ passwordMacth: value }, () => {
            });
        }

        
    }




    handlePostcodeChange = (e) => {


        this.setState({
            postcode: e.target.value, postcodeError: false,

            selectedAddress: [],
            apiAddressList: [],
            addressList: [],
            //city: '',
            //addressline1: '',
            //addressline2: '',
            //addressline3: '',
            //addressline4: '',
            //county: '',
            //country: '',
            //town: ''
        }, () => {
        });


    }


    handleAddress1Line = (e) => {

        this.setState({
            addressline1: e.target.value, addressline1error: false,
        }, () => {
        });
    }

    handleAddress2Line = (e) => {

        this.setState({
            addressline2: e.target.value
        }, () => {
        });
    }

    handleAddress3Line = (e) => {

        this.setState({
            addressline3: e.target.value
        }, () => {
        });
    }

    handleAddress4Line = (e) => {

        this.setState({
            addressline4: e.target.value
        }, () => {
        });
    }



   
    updateErrorList = async (value) => {
        this.setState({
            multipleErrors: value
        }, () => { });
    }



    validate = async () => {
        try {
            await this.updateErrorList(false); // set to false before it checks

            const { email, postcode, selectedAddress, addressline1, city, town } = this.state;

            // valid emaill adress
            let isValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!isValid.test(email) || (isEmpty(email))) {
                this.displayMessage("error", "Invalid Email Address", "This email address is invalid, please re-enter a valid email adress in order to register");
                return false;
            }

            //checks db if email already exists
            const isEmailTaken = await this.isEmailTakenCall(email);
            if (isEmailTaken) {
                this.displayMessage("error", `Email Address is already in use`,
                    `The email address (${email}) is already associated with another account. Please contact FP McCann Sales for further assistance`
                );
                return false;
            }

            if (isEmpty(postcode)) {
                this.setState({ postcodeError: true }, () => { });
                await this.updateErrorList(true);
            }


            if (isEmpty(addressline1)) {
                this.setState({ addressline1error: true }, () => { });
                await this.updateErrorList(true);
            }

            if (isEmpty(town)) {
                this.setState({ townError: true }, () => { });
                await this.updateErrorList(true);
            }

            if (isEmpty(city)) {
                this.setState({ cityError: true }, () => { });
                await this.updateErrorList(true);
            }

            //if (isEmpty(selectedAddress)) {
            //    errorMess('Please use the find address feature to select an address from the list!');
            //    window.scrollTo(0, 0);
            //    return false;
            //}

            if (this.state.passwordMacth !== true) {
                errorMess('Please Check the minimum password length, password complexity and password match requirements.');
                return false;
            }

            // checks to see if any errors were triggered above
            if (this.state.multipleErrors === true) {
                notifyErrorMessage();
                window.scrollTo(0, 0);
                return false;

            }
            else {
                return true; // no errors found
            }


        }
        catch (e) {

        }
    }


    isValidPostcode(p) {
        var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
        return postcodeRegEx.test(p);
    }


    async findAddresses() {
        try {

            const { postcode } = this.state;

            if (this.isValidPostcode(postcode)) {
                var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2})([0-9][A-Z]{2}$)/i;

                var formatPC = postcode.replace(postcodeRegEx, "$1 $2"); // fix postcode format to sui the API

                const key = JSFile.pcKey;
                const api = new Client(key);
                const findResult = await api.find(formatPC);


                if (findResult.isSuccess) {
                    const success = findResult.toSuccess();

                    this.setState({
                        addressList: success.addresses
                    }, () => {
                        //console.log('list ', this.state.addressList);
                    });

                    this.PopulateAPIAddresses();
                }
                else {
                    const failed = findResult.toFailed();
                    console.log(failed);
                }

            }
            else {

                // not a valid UK post
                // Display message
                this.setState({ postcodeError: true }, () => { });
                invalidPCMessage();
            }
        } catch (e) {

        }

    }




    async isEmailTakenCall(email) {
        try {

            const response = await fetch(authController + 'checkexistingemail/' + email, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },

            })
                .then((response) => {
                    if (response.status === 401) {
                        throw new Error("Unauthorised request");
                    }
                    return response;
                })
                .then(res => res.json())
                .catch();

            return response;
        }
        catch (e) {
        }
    }







    //async hanldeRegister() {

    //    try {

    //        if (await this.validate() === true) {

    //            await this.props.loadingPage(true);

    //            const token = await authService.getAccessToken();
    //            const response = await fetch(authController + 'registeruser/', {
    //                method: 'post',
    //                headers: {
    //                    'Content-Type': 'application/json',
    //                    'Authorization': `Bearer ${token}`
    //                },
    //                body: JSON.stringify({
    //                    EmailAddress: this.state.email,
    //                    Telephone: this.state.telephone,
    //                    Active: true,
    //                    PasswordConfirmed: this.state.confirmPassword,
    //                    Address1: this.state.addressline1,
    //                    Address2: this.state.addressline2,
    //                    Address3: this.state.addressline3,
    //                    Address4: this.state.addressline4,
    //                    Postcode: this.state.postcode,
    //                    City: this.state.city,
    //                    Town: this.state.town,
    //                    County: this.state.county,
    //                    Country: this.state.country
    //                })
    //            })

    //            console.log(response);

    //            if (response.isSuccess === true) {
    //                await this.props.loadingPage(false);
    //                this.setState({ didUserSave: true }, () => { });
    //                this.displayMessage("success", "User Updated Successfully!", response.message);
    //            }

    //            else {

    //                this.displayMessage("error", "Oops, an Error has Occurred", response?.message);
    //                await this.props.loadingPage(false);
    //                return;
    //            }

    //            await this.props.loadingPage(false);

    //        }
    //        else {
    //            await this.props.loadingPage(false);
    //        }

    //    } catch (e) {

    //    }

    //}



    async hanldeRegister() {
        try {

            if (await this.validate() === true) {

                await this.props.loadingPage(true);

                const response = await fetch(authController + 'registeruser/', {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        EmailAddress: this.state.email,
                        Telephone: this.state.telephone,
                        Active: true,
                        PasswordConfirmed: this.state.confirmPassword,
                        Address1: this.state.addressline1,
                        Address2: this.state.addressline2,
                        Address3: this.state.addressline3,
                        Address4: this.state.addressline4,
                        Postcode: this.state.postcode,
                        City: this.state.city,
                        Town: this.state.town,
                        County: this.state.county,
                        Country: this.state.country
                    })
                })

                    .then(res => res.json())
                    .catch();

                let data = await response;

                if (data.isSuccess === true) {
                    await this.props.loadingPage(false);
                    this.setState({ didUserSave: true }, () => { });
                    this.displayMessage("success", "Registration Submitted!!", data.message);

                }
                else {
                    await this.props.loadingPage(false);
                    this.displayMessage("error", "Oops, an Error has Occurred", data?.message);
                    return;
                }


            }
        }

        catch (e) {
        }
    }





    PopulateAPIAddresses() {
        try {
            const formatAdd = this.state.addressList.addresses?.map((row, i) => {
                var filtered = row.formatted_address.filter(Boolean);
                var splitRows = filtered.join(', ');
                return (
                    <MenuItem key={i} value={row} style={{ padding: '8px', paddingRight: '30px', paddingLeft: '15px', display: "flex" }}>
                        {splitRows}
                    </MenuItem>
                )
            });
            this.setState({ apiAddressList: formatAdd }, () => { });
        }
        catch (e) {
        }
    };




    onAutoPopulateAddrChange = (event) => {
        try {

            var selectedAddr = event.target.value;

            if (!isEmpty(selectedAddr)) {

                // Auto Populate fields 
                this.setState({
                    city: selectedAddr.town_or_city, cityError: false,
                    addressline1: selectedAddr.line_1, addressline1error: false,
                    addressline2: selectedAddr.line_2,
                    addressline3: selectedAddr.line_3,
                    addressline4: selectedAddr.line_4,
                    county: selectedAddr.county == "County Londonderry" ? "County Derry/Londonderry" : selectedAddr.county,
                    town: isEmpty(selectedAddr.locality) ? selectedAddr.town_or_city : selectedAddr.locality, // city and town can be the same 
                    country: selectedAddr.country,
                    selectedAddress: selectedAddr
                }, () => {
                });

            }
        } catch (e) {

        }
    };


    render() {
        const { classes } = this.props;
        let { showAlert, typeAlert, titleAlert, messageAlert, apiAddressList } = this.state

        //const AdminInputDetails = (key) => {
        //    return (
        //        <div>
        //            <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>Admin Section</h3>
        //            <GridContainer>

        //                <GridItem xs={12} sm={6} md={6}>
        //                    <TextField
        //                        fullWidth
        //                        id="bracnhLokUp"
        //                        select
        //                        label="Customer"
        //                        SelectProps={{
        //                            native: true,
        //                            MenuProps: {
        //                                className: classes.menu
        //                            }
        //                        }}
        //                        helperText="Please select the relevant customer"
        //                        margin="normal"
        //                        variant="outlined"
        //                    >
        //                    </TextField>
        //                </GridItem>

        //                <GridItem xs={12} sm={6} md={6}>
        //                    <TextField
        //                        id="outlined-full-width"
        //                        label="NMBS Reference"
        //                        fullWidth
        //                        margin="normal"
        //                        variant="outlined"
        //                        InputLabelProps={{
        //                            shrink: true
        //                        }}
        //                    />
        //                </GridItem>

        //            </GridContainer>

        //        </div>
        //    );
        //};

        if (this.props.loading === false) {
            return (
                <div className={classes.content}>
                    <div style={{ width: "100%" }}>
                        <div style={{ padding: "10x" }}>
                            <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                                <i className="far fa-user-circle"></i> {' '}
                                Account Details</h3>
                            <Simplert
                                style={{
                                    width: '250px;',
                                    overflow: 'auto',
                                    fontWeight: "600px"
                                }}
                                showSimplert={showAlert}
                                type={typeAlert}
                                title={titleAlert}
                                message={messageAlert}
                                onClose={() => this.handlePopUpMessage()}
                                disableOverlayClick={true}
                                customCloseBtnClass={classes.closebuttonPopUp}
                            />
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6}>
                                    <TextField
                                        id="email"
                                        label="Email"
                                        fullWidth
                                        type="email"
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        value={this.props.email === null ? '' : this.state.email ? this.state.email : ''}
                                        onChange={this.handleEmailChange}
                                        error={this.state.email !== "" && !this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)}
                                        helperText={this.state.email !== "" && !this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}\.[0-9]{1, 3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ? 'Invalid Email Address.' : ' '}
                                    />


                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                    <TextField
                                        id="telephone"
                                        label="Telephone"
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        value={this.state.telephone === null ? "" : this.state.telephone ? this.state.telephone : ''}
                                        pattern="/\B(?=(\d{3})+(?!\d))/g"
                                        type="number"
                                        onChange={this.handlePhoneChange}
                                        error={this.state.telephonerror}
                                        helperText={this.state.telephonerror ? "Please enter a valid telephone!" : null}
                                    />
                                </GridItem>
                            </GridContainer>

                            <GridContainer>                               
                                <GridItem xs={18} sm={9} md={9}>
                                    <FormControl component="fieldset" style={{ marginTop: 16 }}>
                                        <InputLabel shrink={true} style={{ position: 'unset', transform: 'none' }}>What are you registering for?</InputLabel>
                                        <RadioGroup row value={this.state.canRegisterChoice} onChange={this.handleCanRegisterChange}>
                                            <FormControlLabel value="yes" control={<Radio color="primary" />} label="I am an FP McCann Account Holder" />
                                            <FormControlLabel value="no" control={<Radio color="primary" />} label="I do not have an account with FP McCann" />
                                        </RadioGroup>
                                    </FormControl>
                                </GridItem>
                            </GridContainer>
                                    

                            <div>
                                <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                                    <i className="far fa-map"></i> {' '}
                                    Address Details</h3>
                                <GridContainer>


                                    {!isEmpty(this.state.apiAddressList) ?
                                        <GridItem xs={12} sm={12} md={12}>
                                            <TextField
                                                fullWidth
                                                id="apiAdd"
                                                label="Address List"
                                                helperText="Please select your address"
                                                margin="normal"
                                                variant="outlined"
                                                select
                                                focused
                                                onChange={this.onAutoPopulateAddrChange}
                                            >
                                                {apiAddressList}
                                            </TextField>


                                        </GridItem>
                                        : null}


                                    <GridItem xs={6} sm={3} md={3}>
                                        <TextField
                                            style={{ display: "flex" }}
                                            id="postcode"
                                            label="Postcode"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            type="text"
                                            value={this.state.postcode === null ? "" : this.state.postcode ? this.state.postcode : ''}
                                            onChange={this.handlePostcodeChange}
                                            error={this.state.postcodeError}
                                            helperText={this.state.postcodeError ? "Please enter a valid UK postcode!" : null}
                                            focused

                                        />

                                    </GridItem>

                                    <GridItem xs={6} sm={3} md={3} style={{ padding: '16px' }}>
                                        <Button
                                            style={{
                                                borderRadius: 2,
                                                padding: "14px 16px",
                                                fontSize: "12px"
                                            }}

                                            color="instagram"
                                            size="lg"
                                            target="_blank"
                                            onClick={() => this.findAddresses()}
                                        >
                                            <i className="fas fa-location-arrow"></i>
                                            &nbsp;  Find Address
                                        </Button>
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="address1"
                                            label="Address Line 1"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            type="text"
                                            error={this.state.addressline1error}
                                            helperText={this.state.addressline1error ? "Please enter address line 1!" : null}
                                            onChange={this.handleAddress1Line}
                                            value={this.state.addressline1 === null ? "" : this.state.addressline1 ? this.state.addressline1 : ''}
                                            InputLabelProps={{
                                              
                                                shrink: true
                                            }}
                                        />


                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="address2"
                                            label="Address Line 2"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                             
                                            }}
                                            type="text"
                                            onChange={this.handleAddress2Line}
                                            value={this.state.addressline2 === null ? "" : this.state.addressline2 ? this.state.addressline2 : ''}
                                        />
                                    </GridItem>



                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="address3"
                                            label="Address Line 3"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                          
                                            }}
                                            type="text"
                                            onChange={this.handleAddress3Line}

                                            value={this.state.addressline3 === null ? "" : this.state.addressline3 ? this.state.addressline3 : ''}
                                        />


                                    </GridItem>


                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="address4"
                                            label="Address Line 4"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                               
                                            }}
                                            type="text"
                                            onChange={this.handleAddress4Line}
                                            value={this.state.addressline4 === null ? "" : this.state.addressline4 ? this.state.addressline4 : ''}
                                        />


                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="town"
                                            label="Town"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                               
                                            }}
                                            error={this.state.townError}
                                            helperText={this.state.townError ? "Please enter a town!" : null}
                                            type="text"
                                            onChange={this.handleTownChange}
                                            value={this.state.town === null ? "" : this.state.town ? this.state.town : ''}
                                        />


                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="city"
                                            label="City"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                           
                                            }}
                                            error={this.state.cityError}
                                            helperText={this.state.cityError ? "Please enter a city" : null}
                                            type="text"
                                            onChange={this.handleCityChange}
                                            value={this.state.city === null ? "" : this.state.city ? this.state.city : ''}
                                        />


                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="county"
                                            label="County"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                              
                                            }}
                                            type="text"
                                            onChange={this.handleCountyChange}
                                            value={this.state.county === null ? "" : this.state.county ? this.state.county : ''}
                                        />


                                    </GridItem>

                                </GridContainer>
                            </div>


                            <div>
                                <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                                    <i className="fas fa-unlock-alt"></i>
                                    {' '}
                                    Password </h3>
                                <GridContainer>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <PasswordChecklist
                                            rules={["minLength", "specialChar", "number", "capital", "match", "lowercase"]}
                                            minLength={6}
                                            value={this.state.password}
                                            valueAgain={this.state.confirmPassword}
                                            onChange={(isValid) => { this.updatePasswordValResult(isValid) }}
                                            style={{ color: "#151617" }}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="password"
                                            label="Password"
                                            type="password"
                                            autoComplete="current-password"
                                            placeholder="Password...."
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            value={this.state.password === null ? "" : this.state.password ? this.state.password : ''}
                                            onChange={this.handlePasswordChange}
                                        />

                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="passwordConfirm"
                                            label="Confirm Password"
                                            type="password"
                                            autoComplete="current-password"
                                            placeholder="Password...."
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            value={this.state.confirmPassword === null ? "" : this.state.confirmPassword ? this.state.confirmPassword : ''}
                                            onChange={this.handleconfirmPasswordChange}
                                        />
                                    </GridItem>





                                    <GridItem xs={12} sm={12} md={12} style={{ paddingTop: "40px" }}>
                                        <div className={classes.left}>
                                            <Button
                                                style={{
                                                    borderRadius: 2,
                                                    padding: "16px 20px",
                                                    fontSize: "15px"
                                                }}
                                                color="danger"
                                                size="lg"
                                                target="_blank"
                                                onClick={() => history.goBack()}
                                            >
                                                <i className="far fa-window-close"></i>
                                                &nbsp; Cancel
                                            </Button>


                                        </div>

                                        <div className={classes.right}>

                                            {this.state.canRegisterChoice !== 'no' && (
                                            <Button
                                                style={{

                                                    borderRadius: 2,
                                                    padding: "16px 20px",
                                                    fontSize: "15px"
                                                }}

                                                color="success"
                                                size="lg"
                                                target="_blank"
                                                onClick={() => this.hanldeRegister()}
                                            >
                                                <i className="fas fa-check"></i>
                                                &nbsp;  Register
                                            </Button>
                                            )}
                                        </div>
                                    </GridItem>
                                </GridContainer>


                                <div>
                                    <ToastContainer
                                        position="bottom-right"
                                        autoClose={5000}
                                        hideProgressBar={false}
                                        newestOnTop={false}
                                        closeOnClick
                                        rtl={false}
                                        pauseOnFocusLoss
                                        draggable
                                        pauseOnHover
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );

        }
        else {
            return (<LoadingData text={"Saving Data, Please Wait...."} />)
        }
    }
}


const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
        username: state.userReducer.savedUserName,
        loading: state.userReducer.loadingPage
    };
};

export default compose(withRouter, connect(mapStateToProps, { loadingPage }))(withStyles(useStyles)(RegisterInputClass));

